import { fetchAiBookmarkedImages, fetchAiImages } from './effects';
import { $aiImages } from './states';

// AI Images
$aiImages.on(fetchAiImages.doneData, (_, data) => data);

// AI bookmark images
$aiImages.on(fetchAiBookmarkedImages.doneData, (_, data) => data);
